import api from "src/apis/api";
import { buildImageFormData, hasImageChanges } from "src/utils/imageFormData";

// ── Fetch ────────────────────────────────────────────────────────────────────
export async function fetchPropertyListings({
  page = 1,
  per_page = 20,
  listing_type = "",
  status = "",
  property_type = "",
  city = "",
  q = "",
} = {}) {
  const params = new URLSearchParams();
  params.set("page", page);
  params.set("per_page", per_page);
  if (listing_type) params.set("listing_type", listing_type);
  if (status) params.set("status", status);
  if (property_type) params.set("property_type", property_type);
  if (city) params.set("city", city);
  if (q) params.set("q", q);

  const { data } = await api.get(`/api/v1/property_listings?${params}`);
  return data;
}

// Photos go under the `photos[]` field; removals under `remove_photo_ids[]`.
const PHOTO_KEYS = { fileKey: "photos", removeKey: "remove_photo_ids" };

// ── Create ───────────────────────────────────────────────────────────────────
export async function createPropertyListing(payload, photos = {}) {
  if (hasImageChanges(photos)) {
    const form = buildImageFormData("property_listing", payload, { ...photos, ...PHOTO_KEYS });
    const { data } = await api.post("/api/v1/property_listings", form, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return data;
  }
  const { data } = await api.post("/api/v1/property_listings", {
    property_listing: payload,
  });
  return data;
}

// ── Update ───────────────────────────────────────────────────────────────────
export async function updatePropertyListing(id, payload, photos = {}) {
  if (hasImageChanges(photos)) {
    const form = buildImageFormData("property_listing", payload, { ...photos, ...PHOTO_KEYS });
    const { data } = await api.patch(`/api/v1/property_listings/${id}`, form, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return data;
  }
  const { data } = await api.patch(`/api/v1/property_listings/${id}`, {
    property_listing: payload,
  });
  return data;
}

// ── Delete ───────────────────────────────────────────────────────────────────
export async function deletePropertyListing(id) {
  const { data } = await api.delete(`/api/v1/property_listings/${id}`);
  return data;
}
